import React, { useState, useEffect } from "react";
import './classes/SalespersonSidebar.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Link from '@mui/material/Link';
import { configData } from "../config";
import { useLocation,useParams } from 'react-router-dom';

const SalespersonSidebar = ({ updateToggle, drupal_uid}) => {
    const [masquerade, setMasquerade] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [userLoggedinId, setUserLoggedinId] = useState([]);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [options, setOptions] = useState([]);
    const [salespersonactivity, setSalespersonActivity] = useState([]);
    const app_url = configData.APP_URL;
    const domainName = window.location.host.replace(/^https?:\/\//, '');
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const loggedin_uid = localStorage.getItem('uid');
    const[agentNews, setAgentNews] = useState({});
    const[scoutNews, setScoutNews] = useState({});
    const location = useLocation();
    const path = location.pathname;
    const ItemToShowinViewTab = path.includes('/users/') || path.includes('/user/');
    const currentPath = location.pathname;
    const hiddenPaths = [
        "/user/", "/users", "/my_athletes", "/add_athlete", "/resource_library", "/agents-directory", "/my_agents_account",
        "/add/scout-report", "/my_reports", "/my_scout_request_reports", "/scouts-directory", "/my_scouts_account", "/scouting-requests", "/node/841/submission"
    ];
    const isHidden = hiddenPaths.some(path =>
        currentPath.includes(path)
    );
const agencyDomains = [
    configData.RSMWW_AGENCY_DOMAIN,
    configData.RSMWW_AGENCY_DOMAIN1
  ];
  const scoutDomains = [
    configData.RSMWW_SCOUT_DOMAIN,
    configData.RSMWW_SCOUT_DOMAIN1,
    configData.RSMWW_SCOUT_DOMAIN2
  ];
    useEffect(() => {
         
            const mask = localStorage.getItem('masquerade');
           
            if(mask === 1) {
             
              setMasquerade(true);
            } else {
              
              setMasquerade(false);
            }
    }, []);
    useEffect(() => {
      getagentnews();
      getscoutnews();
      getsalespersonactivity();
      getuserloggedinroles();
    // Implement debouncing here if needed
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        // Replace with your actual API call
        const response = await fetch(app_url+'user/getapplicationuserlist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
  
  const renderOption = (props, option) => (
  <li {...props}>
    <Link href={option.link} color="inherit" underline="hover">
      {option.label}
    </Link>
  </li> 
);

const getOptionLabel = (option) => option.label;

const onChange = (event, newValue) => {
  if (newValue && newValue.link) {
    window.location.href = newValue.link;
  }
};
async function getagentnews() {  
    const response = await fetch(
          app_url+'smwwagency/getagentnews',
        {
            method: "GET",

            headers: {
            'Content-Type': 'application/json',
            },
        }
    )           
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
        setAgentNews(responsedata.data.result);
    } 
}
async function getscoutnews() {         
  const response = await fetch(
        app_url+'smwwscout/getscoutnews',
      {
          method: "GET",

          headers: {
          'Content-Type': 'application/json',
          },
      }
  )           
  const responsedata = await response.json();
  if(responsedata.data.msg === "Success") {
      setScoutNews(responsedata.data.result);
  } 
}
async function getsalespersonactivity() {
   
         try {
            const response = await fetch(
                app_url+'report/getsalespersonactivity',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonActivity(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
  async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setUserLoggedinId(responsedata.data.user);
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
// console.log(
//   loggedin_drupal_uid,
//   typeof loggedin_drupal_uid,
//   userLoggedinId,
//   typeof userLoggedinId
// );
const isReady = 
  domainName !== undefined &&
  Array.isArray(userLoggedInRoles) &&
  userLoggedInRoles.length > 0;

if (!isReady) {
    return <></>;
} 
    return(
    <>
    {!isReady ? (
        <></>
    ) : (
        <>
        {(agencyDomains.includes(domainName) && 
        userLoggedInRoles.includes(configData.ROLE_AGENT) &&
        !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) && (
            <div className="agent-right">
                <div id="sidebar-third" className="agent-grid_4">
                    <div className="agent-region agent-region-sidebar-third">
                        <div id="block-smww-smww-operations" className="agent-block agent-block-smww"></div>
                            <h1>Quick Links</h1>
                            {isHidden && (<>
                            <ul className="user-opt-menu">
                                <li>
                                    {/* <a href={`/users/${userEmail}`}>Home</a> */}
                                    <a href={`/user/${loggedin_drupal_uid}`}>Home</a>
                                </li>
                                <li>
                                    <a href="/pending_athletes">Athletes Looking for an Agent</a>
                                </li>
                                <li>
                                    <a href="/my_athletes">My Athletes</a>
                                </li>
                                <li>
                                    <a href="/add_athlete">Create Athlete</a>
                                </li>
                                <li>
                                    <a href="/resource_library">Resource Library</a>
                                </li>
                                <li>
                                    <a href="/agents-directory">Agent Directory</a>
                                </li>
                                <li>
                                    <a href={`/user/${loggedin_drupal_uid}/edit`}>Manage My Public Profile</a>
                                </li>
                                <li>
                                    <a href="/my_agents_account">My Account</a>
                                </li>
                        </ul>

                        <a style={{color:"#fff"}} href="https://smww.zoom.us/j/804154184" rel="nofollow" class="form-submit" target="_blank">Sunday Chat Link</a>
                        </>)}
                        <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                            <a href={`https://${configData.RSMWW_DOMAIN}/smww_pay`}>
                                <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                            </a>
                        </li>
                        {(ItemToShowinViewTab && 
                        !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && (
                            <>
                                {agentNews.length > 0 && (
                                    <div className="agent-news-container">
                                        <h3>Agent News</h3>
                                        {agentNews.map((agtnews, index)=> ( 
                                            <div key={index}>       
                                            <ul>
                                                <li style={{border: "1px solid #000", margin: "0 0 12px 21px"}}>
                                                    <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                                    <a href={agtnews.url}>{agtnews.head}</a>
                                                    </div>
                                                <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: agtnews.body }} /></div> 
                                                </li>
                                            </ul>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </> 
                        )}
                    </div>
                </div>
            </div>
        )} 
        {(scoutDomains.includes(domainName) && 
        userLoggedInRoles.includes(configData.ROLE_SCOUT) &&
        !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) && (
            <div className="scout-right">
                <div id="sidebar-third" className="scout-grid_4">
                    <div className="scout-region scout-region-sidebar-third">
                        <div id="block-smww-smww-operations" className="scout-block agent-block-smww"></div>
                        <h1>Quick Links</h1>
                        {isHidden && (<>
                        <ul className="user-opt-menu">
                            <li><a href={`/user/${loggedin_drupal_uid}`}>Dashboard Home</a></li>
                            <li><a href="/node/add/scout-report">Upload a new report</a></li>
                            <li><a href="/my_reports">My reports</a></li>
                            <li><a href="/my_scout_request_reports">My Scout Request reports</a></li>
                            <li><a href="/scouts-directory">Scouts Directory</a></li>
                            <li><a href="/admin/reports/scouting_request">View Scouting Requests</a></li> 
                            <li><a href="/resource_library">Resource Library</a></li>
                            <li><a href={`/user/${loggedin_drupal_uid}/edit`}>Manage My Public Profile</a></li>
                            <li><a href="/my_scouts_account">My Account</a></li>
                        </ul>
                            <a style={{color:"#fff"}} href="https://smww.zoom.us/j/804154184" rel="nofollow" class="form-submit" target="_blank">Sunday Chat Link</a>  
                        </>)}
                        {!userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) &&
                        <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                            <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                            <li style={{paddingLeft: "0px"}}>
                                <a href={`https://${configData.RSMWW_DOMAIN}/smww_pay`}>
                                <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                            </li>
                        </ul>  
                        }
                        {(ItemToShowinViewTab && 
                        !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && (
                            <>
                                {scoutNews.length > 0 && (
                                <div className="scout-news-container">
                                <h3>Scout News</h3>
                                    {scoutNews.map((sctnews, index)=> ( 
                                    <div key={index}>       
                                        <ul>
                                            <li style={{border: "1px solid #000", margin: "0 0 12px 21px"}}>
                                            <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                                <a href={sctnews.url}>{sctnews.head}</a>
                                            </div>
                                            <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: sctnews.body }} /></div>
                                            </li>
                                        </ul>
                                    </div>
                                    ))}
                                </div>
                                )}
                            </> 
                        )}      
                    </div>
                </div>
            </div>
        )} 
        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
        <div className="salesperson-right">
            <div id="sidebar-third" className="salesperson-grid_4">
                <div className="salesperson-region salesperson-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="salesperson-block salesperson-block-smww"></div>
                    <div>
                        {!((agencyDomains.includes(domainName) && userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && userLoggedInRoles.includes(configData.ROLE_AGENT)) ||
                        (scoutDomains.includes(domainName) && userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && userLoggedInRoles.includes(configData.ROLE_SCOUT))) &&
                        <h1>Quick Links</h1>
                        }
                        <ul>
                            {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) && ItemToShowinViewTab) && 
                            <>
                            <li><a href="/saadmin-people">People</a></li>
                            <li><a href="/admin/config/content/profile-approval">Approve Profile Changes</a></li>
                            <li><a href="/admin/reports/agent_athlete_scout">Scout, Agent and Athlete Export</a></li>
                            <li><a href="/resource_library">Resource Library</a></li>
                            </>
                            }
                            {!((agencyDomains.includes(domainName) && userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && userLoggedInRoles.includes(configData.ROLE_AGENT))  ||
                            (scoutDomains.includes(domainName) && userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && userLoggedInRoles.includes(configData.ROLE_SCOUT))) &&
                                <>
                                    <li className='salesperson-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                                    {((userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                                    <li>
                                    <a href={`https://${configData.RSMWW_DOMAIN}/smww_pay`}>
                                    <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                    </a>
                                    </li>)}
                                    {masquerade && (
                                    <li>
                                    <a href={`https://${configData.RSMWW_DOMAIN}/smww_pay`}>
                                    <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                    </a>
                                    </li>
                                    )}      
                                    {masquerade && (
                                        <li>
                                        <a className="salesperson-quick_link_anchor" href={`/miscellaneous/charge/${drupal_uid}`}>
                                            Miscellaneous Charge
                                        </a>
                                        </li>
                                    )}
                                </>
                            }
                            {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) || (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && 
                            <li><a href={"/user/"+localStorage.getItem('uid')}>Dashboard Home</a></li>
                            }
                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) && <>
                                {agencyDomains.includes(domainName) ? <li><a href="/my_agents_account">My Account</a></li>: <li><a href="/my_scouts_account">My Account</a></li>}
                            </>}
                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) && 
                            <li><a href="/manage/people">People</a></li>
                            }
                            {(userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && 
                            <li><a href="/my_sales_tasks">My Tasks</a></li>
                            }
                            {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) || (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && 
                            <>
                            <li><a href="/app-list">Applications</a></li>
                            <li><a href="/salesperson/create/application">Add Application</a></li>
                            </>}
                            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && 
                            <li><a target="_blank" href={configData.DRUPAL_DOMAIN_URL+"/user/login"}>Manage Website</a></li>
                            }
                        </ul>
                    </div>
                    <div>
                        <h1>Applicant & Agent Search</h1>
                        <Autocomplete
                            id="user_search"
                            disablePortal
                            options={options}
                            sx={{ width: 300 }}
                            renderOption={renderOption}
                            getOptionLabel={getOptionLabel}
                            onChange={onChange}
                            renderInput={(params) => <TextField {...params} onChange={(event) => setSearchValue(event.target.value)}/>}
                        />
                    </div>
                    <div>
                        <h1>Daily Salesperson Activity</h1>
                        <div className="salespeople-content">
                            <div className="salesperson-activity-graph-wrapper">
                                {salespersonactivity.length > 0 &&
                                <>
                                {salespersonactivity.map((item, idx) => (
                                <div key={item['name']}>
                                    <div className="salespeople-members">
                                    <b>{item['name']}</b>
                                    </div>
                                    <div className="salesperson-progress-full-width">
                                    <div
                                        className={`salesperson-progress-bar salesperson0${idx + 1}`}
                                        style={{ width: item['percent']+'%'}}
                                    >
                                        {item['event_count']}
                                    </div>
                                    </div>
                                    <div className="salesperson-event-count-right">{item['event_count']}</div>
                                    <div className="salesperson-clearfix"></div>
                                </div>
                                ))}
                                </>
                                }
                                <p>*The number of users the salesperson has contacted or updated each day</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {(agencyDomains.includes(domainName) && ItemToShowinViewTab) && <>
                {agentNews.length > 0 && (
                    <div>
                        <h3>Agent News</h3>
                        {agentNews.map((agtnews, index)=> ( 
                            <div key={index}>       
                            <ul style={{padding: "0px"}}>
                                <li style={{border: "1px solid #000", margin: "0 0 12px 21px", textDecoration: "none"}}>
                                    <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                    <a href={agtnews.url}>{agtnews.head}</a>
                                    </div>
                                <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: agtnews.body }} /></div> 
                                </li>
                            </ul>
                            </div>
                        ))}
                    </div>
                )}
                </>}
                {(scoutDomains.includes(domainName) && ItemToShowinViewTab) && <>
                {scoutNews.length > 0 && (
                    <div>
                    <h3>Scout News</h3>
                        {scoutNews.map((sctnews, index)=> ( 
                        <div key={index}>       
                            <ul style={{padding: "0px"}}>
                                <li style={{border: "1px solid #000", margin: "0 0 12px 21px", textDecoration: "none"}}>
                                <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                    <a href={sctnews.url}>{sctnews.head}</a>
                                </div>
                                <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: sctnews.body }} /></div>
                                </li>
                            </ul>
                        </div>
                        ))}
                    </div>
                )}
                </>}
            </div>
        </div>
        ) : ((loggedin_uid && !Number.isNaN(loggedin_uid) && userLoggedinId) && 
        !((agencyDomains.includes(domainName) && 
        userLoggedInRoles.includes(configData.ROLE_AGENT)) ||
    (scoutDomains.includes(domainName) && 
        userLoggedInRoles.includes(configData.ROLE_SCOUT)))) ? (                        
            <div>
                <h1>Quick Links</h1>
                <ul style={{padding: "0px"}}>
                    <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedinId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                    <li>
                    <a href={"https://"+configData.RSMWW_DOMAIN+"/smww_pay"}>
                    <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                    </a>
                    </li>          
                    {(localStorage.getItem('masquerade') == 1 && userLoggedInRoles.includes(configData.ROLE_APPLICATION)) && (
                        <li>
                        <a className="salesperson-quick_link_anchor" href={`/miscellaneous/charge/${userLoggedinId.drupal_uid}`}>
                            Miscellaneous Charge
                        </a>
                        </li>
                    )} 
                    </ul>
            </div>
        ) : (<></>)}
        </>
        )}
      </>
    );
};

export default SalespersonSidebar;